import './fonts.css';

// src/App.js
import React from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { PricingProvider } from "./context/PricingContext";
import { ToastContainer } from "react-toastify";

import Login from './components/Login';
import Register from './components/Register';
import UpdateUserData from './components/UpdateUserData';
import ProtectedRoute from './components/ProtectedRoute';
import AdminCouponManager from './components/AdminCouponManager';
import './index.css'; // Make sure this line is present
import LogoutButton from './components/LogoutButton';
import AdminRoute from './components/AdminRoute';
import Admin from './components/Admin';
import CreateOrder from './components/CreateOrder';
import RegisterMain from './components/RegisterMain';
import Home from './components/Home';
import XboxCoins from './components/XboxCoins';
import TawkChat from './components/TawkChat';
import ReferralRedirect from './components/ReferralRedirect';


import './index.css'; // For index.css
// OR
import './App.css'; // For App.css
import PlaystatioCoins from './components/PlaystatioCoins';
import PcCoins from './components/PcCoins';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import ManageAccount from './components/ManageAccount';
import '@fontsource/inter';
import SellCoins from './components/SellCoins';
import XboxCheckout from './components/XboxCheckout';
import TrackOrder from './components/TrackOrder';
import OrderDetails from './components/OrderDetails';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import TermsAndConditions from './components/TermsAndConditions';
import Copyright from './components/Copyright';
import AmlPolicy from './components/AmlPolicy';
import Refundpolicy from './components/Refundpolicy';
import OrderLists from './components/OrderLists';
import OrderInfo from './components/OrderInfo';
import BuyingPrice from './components/BuyingPrice';
import AllUsers from './components/AllUsers';
import CashBack from './components/CashBack';
import OrdersEmail from './components/OrdersEmail';
import SellOrders from './components/SellOrders';
import PromoCodes from './components/PromoCodes';
import ActivePromoCodes from './components/ActivePromoCodes';
import SetSellCoinsPrices from './components/SetSellCoinsPrices';
import SellOrderInfo from './components/SellOrderInfo';
import NavbarMobile from './components/NavbarMobile';
import UpdateProfile from './components/UpdateProfile';
import SuccessPage from './components/SuccessPage';
import CancelPage from './components/CancelPage';
import OrderSuccess from './components/OrderSuccess';
import AffiliateProgram from './components/AffiliateProgram';
import SignedInAffiliate from './components/SignedInAffiliate';
import EditProfile from './components/EditProfile';
import GuestPop from './components/GuestPop';
import MobileProfileManagement from './components/MobileProfileManagement';
import AllAdminOrders from './components/AllAdminOrders';
import PaymentIssue from './components/PaymentIssue';
import UpdateCredentials from './components/UpdateCredentials';

const App = () => {
  return (
    <PricingProvider>
      <ToastContainer />

      <AuthProvider>
        <UserProvider>
          <Router>
            {/* <LogoutButton /> */}


            <div className="">

              <Navbar />
              <TawkChat />

            </div>
            {/* <div className="block sm:hidden">
              <NavbarMobile />
            </div> */}

            <div>
              <Routes>

                <Route path="/update-credentials/:orderId" element={<UpdateCredentials />} />
                <Route path="/create-order" element={<CreateOrder />} /> {/* Fixed here */}
                {/* <Route path="/login" element={<Login />} /> */}
                <Route path="/register" element={<Register />} />
                <Route path="/payment-issue" element={<PaymentIssue />} />
                <Route path="/:code" element={<ReferralRedirect />} />


                <Route path="/register-user" element={<RegisterMain />} />
                <Route path="/buy-xb-coins" element={<XboxCoins />} />
                <Route path="/buy-ps-coins" element={<PlaystatioCoins />} />
                <Route path="/buy-pc-coins" element={<PcCoins />} />
                <Route path="/sellCoins" element={<SellCoins />} />
                <Route path="/xb-checkout" element={<XboxCheckout />} />
                <Route path="/track-order" element={<TrackOrder />} />
                <Route path="/order-details/:orderId" element={<OrderDetails />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="/term-conditions" element={<TermsAndConditions />} />
                <Route path="/copyright" element={<Copyright />} />
                <Route path="/aml-policy" element={<AmlPolicy />} />
                <Route path="/refund-policy" element={<Refundpolicy />} />
                <Route path="/success" element={<SuccessPage />} />
                <Route path="/cancel" element={<CancelPage />} />
                <Route path="/orderSuccess" element={<OrderSuccess />} />
                <Route path="/affiliateProgram" element={<AffiliateProgram />} />
                <Route path="/GuestPop" element={<GuestPop />} />
                <Route path="/manageAccMob" element={<MobileProfileManagement />} />

                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/reset-password/:token" element={<ForgotPassword />} />
                <Route path="/updateProfile" element={<ProtectedRoute element={<UpdateUserData />} />} />
                <Route path="/editProfile" element={<ProtectedRoute element={<EditProfile />} />} />
                <Route
                  path="/UseraffiliateProgram"
                  element={<ProtectedRoute element={<SignedInAffiliate />} />}
                />

                <Route path="/updateUserProfile" element={<ProtectedRoute element={<UpdateProfile />} />} />

                <Route path="/manageAccount" element={<ProtectedRoute element={<ManageAccount />} />} />


                {/* Admin Route wrapping admin components */}
                <Route path="/admin" element={<AdminRoute />}>
                  <Route path="" element={<Admin />} />
                </Route>
                <Route path="/admin" element={<AdminRoute />}>
                  <Route path="admin-orderlists" element={<OrderLists />} />
                  <Route path="/admin/order-info/:orderId" element={<OrderInfo />} />
                  <Route path="/admin/sell-order-info/:id" element={<SellOrderInfo />} />
                  <Route path="admin-pricing" element={<BuyingPrice />} />
                  <Route path="coupon-manager" element={<AdminCouponManager />} />
                  <Route path="cash-back" element={<CashBack />} />
                  <Route path="all-users" element={<AllUsers />} />
                  <Route path="all-emails" element={<OrdersEmail />} />
                  <Route path="sell-orders" element={<SellOrders />} />
                  <Route path="promo-codes" element={<PromoCodes />} />
                  <Route path="active-promo-codes" element={<ActivePromoCodes />} />
                  <Route path="setSellCoinsPrices" element={<SetSellCoinsPrices />} />
                  <Route path="showAllOrders" element={<AllAdminOrders />} />



                </Route>

                <Route path="/" element={<Home />} />
              </Routes>
            </div>
            <Footer />
          </Router>
        </UserProvider>
      </AuthProvider>
    </PricingProvider>
  );
};

export default App;
